<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    :width="size"
    :height="size"
  >
    <rect
      :x="x"
      :y="x"
      :width="width"
      :height="width"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      :fill="fill"
    />
  </svg>
</template>
<script>
export default {
  name: 'icon-rect',
  props: {
    size: {
      type: Number,
      default: 16,
    },
    stroke: {
      type: String,
      default: '#606266',
    },
    strokeWidth: {
      type: Number,
      default: 2,
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
  computed: {
    x() {
      return 0 + this.strokeWidth / 2
    },
    width() {
      return this.size - this.strokeWidth
    },
  },
}
</script>